import { createAction, createReducer } from '@reduxjs/toolkit';
import type { ICheckABState } from 'reactApp/modules/checkAB/checkAB.types';

const initialState: ICheckABState = {
    isCheckAB: false,
};

export const getCheckABRequest = createAction('checkAB/getCheckABRequest');
export const getCheckABSuccess = createAction('checkAB/getCheckABSuccess');
export const getCheckABFailure = createAction('checkAB/getCheckABFailure');

export const checkABReducer = createReducer(initialState, {
    [getCheckABSuccess.type]: (state: ICheckABState) => {
        state.isCheckAB = true;
    },
    [getCheckABFailure.type]: (state: ICheckABState) => {
        state.isCheckAB = false;
    },
});
